import api from '../api';

export function listProjects(accountId) {
    return api.get(`/projects?account_id=${accountId}`).then(response => response.data);
}

export function getProject(projectId) {
    return api.get(`/projects/${projectId}`).then(response => response.data);
}

export function createProject(accountId, name, description) {
    return api.post(`/projects`, {
        'account_id': accountId,
        'name': name,
        'description': description
    }).then(response => response.data);
}

export function removeProject(projectId) {
    return api.delete(`/projects/${projectId}`).then(response => response.data);
}

export function updateProject(projectId, name, description, colour) {
    return api.patch(`/projects/${projectId}`, {
        'name': name,
        'description': description,
        'colour': colour,
    }).then(response => response.data);
}